// utils/playNotification.ts
export const playNotification = () => {
  try {
    // const audio = new Audio("/sounds/notify.mp3");
    const audio = new Audio("/sounds/bip.mp3");
    audio.play().catch(() => {
      console.log("[SignalR] ⚠ Não foi possível tocar som");
    });
    // console.log("[SignalR] 🔔 play");
  } catch (e) {
    console.error("Erro ao tocar áudio", e);
  }
};

export const vibrate = () => {
  if (navigator.vibrate) {
    navigator.vibrate([150, 70, 150]); // vibra -> pausa -> vibra
  }
};
